<div class="modal-header">
  <h4 class="modal-title">{{ 'user_profile' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
</div>

<div class="modal-body">
  <ts-person-card [person]="person" [card_wrap]="false" [clear_enabled]="false" />
</div>
